// Scroll parallax (GSAP ScrollTrigger) driving two effects that share one GSAP load: the « Image / Vidéo » block translates its parent, and the « Texte + images (parallaxe) » section moves its 3 photos at different speeds; loaded on demand once, reduced-motion respected, Lenis synced by smooth-scroll.js.
(function () {
  var GSAP_SRC = "https://cdn.jsdelivr.net/npm/gsap@3.12.5/dist/gsap.min.js";
  var ST_SRC = "https://cdn.jsdelivr.net/npm/gsap@3.12.5/dist/ScrollTrigger.min.js";

  var prefersReducedMotion =
    window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches;

  function loadScript(src) {
    return new Promise(function (resolve, reject) {
      // Évite de recharger un script déjà présent.
      var existing = document.querySelector('script[src="' + src + '"]');
      if (existing) {
        if (existing.dataset.loaded === "true") return resolve();
        existing.addEventListener("load", function () {
          resolve();
        });
        existing.addEventListener("error", reject);
        return;
      }
      var s = document.createElement("script");
      s.src = src;
      s.async = true;
      s.addEventListener("load", function () {
        s.dataset.loaded = "true";
        resolve();
      });
      s.addEventListener("error", reject);
      document.head.appendChild(s);
    });
  }

  function loadGsap() {
    if (window.gsap && window.ScrollTrigger) return Promise.resolve();
    return loadScript(GSAP_SRC).then(function () {
      return loadScript(ST_SRC);
    });
  }

  // --- 1) Block « Image / Vidéo » ---------------------------------------
  function initImageBlock(block) {
    if (block.dataset.rtParallaxBound === "true") return;
    block.dataset.rtParallaxBound = "true";

    // The media's parent div is animated rather than the image alone, so there is no zoom or cropping; `block` stays the trigger, distinct from the animated element for a safe position calc.
    var target = block.querySelector(".rt-media__inner");
    if (!target) return;

    var gsap = window.gsap;
    gsap.registerPlugin(window.ScrollTrigger);

    // Amplitude du déplacement, en % de la hauteur du média (yPercent).
    var amount = parseFloat(block.getAttribute("data-rt-parallax-intensity"));
    if (isNaN(amount)) amount = 15;
    amount = Math.max(1, Math.min(40, amount));

    gsap.fromTo(
      target,
      { yPercent: amount },
      {
        yPercent: -amount,
        ease: "none",
        scrollTrigger: {
          trigger: block,
          start: "center bottom",
          end: "center top",
          scrub: true,
          invalidateOnRefresh: true,
        },
      },
    );
  }

  // --- 2) Section « Texte + images (parallaxe) » ------------------------
  // Vitesse (yPercent final) de chaque photo, dans l'ordre item 1 → 3.
  var SECTION_SPEEDS = [-30, -15, -60];

  function initParallaxSection(wrapper) {
    if (wrapper.dataset.parallaxSectionBound === "true") return;
    wrapper.dataset.parallaxSectionBound = "true";

    var gsap = window.gsap;
    gsap.registerPlugin(window.ScrollTrigger);

    // Chaque photo remonte (yPercent 0 → vitesse) pendant que le centre du
    // wrapper traverse le viewport. Le déclencheur commun est le wrapper.
    for (var i = 0; i < SECTION_SPEEDS.length; i++) {
      var image = wrapper.querySelector(
        ".text_image_parallax_item_" + (i + 1) + " .text_image_parallax_image",
      );
      if (!image) continue;

      gsap.to(image, {
        yPercent: SECTION_SPEEDS[i],
        ease: "none",
        scrollTrigger: {
          trigger: wrapper,
          start: "center bottom",
          end: "center top",
          scrub: true,
          invalidateOnRefresh: true,
        },
      });
    }
  }

  function init(scope) {
    var root = scope && scope.querySelectorAll ? scope : document;
    var blocks = root.querySelectorAll("[data-rt-parallax]");
    var sections = root.querySelectorAll(".text_image_parallax_wrapper");
    if (!blocks.length && !sections.length) return;

    // Respecte « réduire les animations » : on ne charge pas GSAP, tout reste
    // au repos.
    if (prefersReducedMotion) return;

    loadGsap()
      .then(function () {
        blocks.forEach(initImageBlock);
        sections.forEach(initParallaxSection);
      })
      .catch(function () {
        // Échec du chargement de GSAP : rien n'est animé (contenu au repos).
      });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", function () {
      init();
    });
  } else {
    init();
  }

  // Ré-initialisation dans l'éditeur de thème Shopify lors d'un rechargement
  // de section (bloc ou section peut réapparaître avec la parallaxe active).
  document.addEventListener("shopify:section:load", function (event) {
    init(event.target);
  });
})();
